// libraries
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateCurrentPage } from 'state/slices/app';
// styles
import injectSheet from "react-jss";
import styles from './unsavedchangeconfirmpopup_styles.js';
import { UnsavedMessage, displayModal } from '@insticator/insticator-ui';


/* ========== ~~~~~~~~~~ UNSAVED CHANGE CONFIRM POPUP ~~~~~~~~~~ ========== */
const UnsavedChangeConfirmPopup = injectSheet(styles)(({ newPage }) => {
  // TODO: Add a boolean to check if there's an unsaved changes in commenting config v2
  const dispatch = useDispatch();
  const currentPage = useSelector(state => state.app.currentPage);


  return (
    <UnsavedMessage currentPage={currentPage} primaryAction={() => {
      dispatch(displayModal(false))
      dispatch(updateCurrentPage(newPage))
    }}  />
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default UnsavedChangeConfirmPopup